<div class="col-xs-12 col-md-12 page-heading-strip navy-blue no-padding mobile-pos-fixed" *ngIf="showOtpDrawer">
    <div class="col-xs-12 col-md-12 spc-between">
        <h3 class="page-heading">

            <span>OTP Verification</span>
        </h3>
    </div>
</div>
<div class="col-xs-12 col-md-12 landing-spec no-padding">

    <img class="col-lg-7 col-md-7 col-xs-12 no-padding hide-desktop mobile-banner"
        src="assets/img/Health_Insurance_assets_Mobile_banner_Mobile.png" alt="banner image" *ngIf="!bflJourney">
    <div class="banner-text hide-desktop" *ngIf="!bflJourney">
        <p>Stay protected against <br>
            rising medical costs, <br>
            with Health Insurance</p>

    </div>
    <img class="col-lg-7 col-md-7 col-xs-12 no-padding hide-desktop getgoing-banner-img-bfl"
        src="assets/img/medical_Image_Mobile.png" alt="banner image" *ngIf="bflJourney">

    <!-- </div> -->
    <!-- <ng-container *ngTemplateOutlet="oldContent"></ng-container> -->
    <ng-container *ngTemplateOutlet="newContent"></ng-container>

    <div class="col-lg-5 col-md-5 col-xs-12 no-padding">
        <div *ngIf="!showOtpDrawer || isMobile()">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="clearfix no-gutter-sm">
                    <div class="tabContainer pr-desktop-30">
                        <section *ngIf="showLoader && !isMobileFlag">
                            <app-loader></app-loader>
                        </section>
                        <div class="clearfix bottom-line-only">
                            <div class="col-xs-12 col-md-12 fullscreen-ts">
                                <form [formGroup]="GetGoingFormGroup" [id]="isHealthQuoteId">
                                    <div class="row top-spc-20 mob-top-10">
                                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 mobile-no-pad">
                                            <div class="col-xs-12 col-md-12">
                                                <p class="card-page-heading">Get Policy Quote</p>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 mobile-no-pad">
                                            <!-- insuring for -->
                                            <!-- <div class=" col-xs-12 col-md-12 top-spc-20 m-b-5">
                                                <div class="input-group"
                                                    [ngClass]="FormValidators.FieldHasErrors(GetGoingFormGroup,'insuredMembers') ? 'text-danger':'' ">
                                                    <input #input5 type="text"
                                                        class="form-control text-capitalize formControl insuredMember text-nowrap"
                                                        autocomplete="off" minlength="1" readonly
                                                        formControlName="insuredMembers"
                                                        (paste)="event.preventDefault()"
                                                        (keypress)="FormValidators.IsAlphabet($event)"
                                                        [ngClass]="IsEdit ? 'border-spc input-disable' : ''"
                                                        (click)="openDrawer('insuringForDrawer')">
                                                    <span class="font-18 bold-font break-email insuring-span"
                                                        *ngIf="IsEdit === true"
                                                        (click)="openDrawer('insuringForDrawer')">
                                                        {{GetGoingFormGroup.get('insuredMembers').value}}
                                                    </span>
                                                    <label class="formLabel"
                                                        [ngClass]="MembersAddedLable ? 'atTop' : 'atBottom'"
                                                        (click)="openDrawer('insuringForDrawer')">Insuring For
                                                    </label>
                                                    <i *ngIf="!(GetGoingFormGroup.controls['insuredMembers'].value) || IsEdit === true"
                                                        class="icon-spec-value drop-down icon-a_downward_arrow hightlight-color"
                                                        (click)="openDrawer('insuringForDrawer')">
                                                    </i>
                                                </div>
                                                <div class="clearfix"></div>
                                                <div class="guidance-text">Select the members you want to insure
                                                </div>
                                                <div *ngIf="FormValidators.FieldHasErrors(GetGoingFormGroup,'insuredMembers')"
                                                    class="bottom-spc-10">
                                                    <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'insuredMembers','required')">
                                                        This is a mandatory field.</div>
                                                </div>
                                            </div> -->

                                            <!-- Name Field -->
                                            <div class="form-group col-xs-12 col-md-12 top-spc-20">
                                                <div class="input-group"
                                                    [ngClass]="FormValidators.FieldHasErrors(GetGoingFormGroup,'proposerName') ? 'text-danger':'' ">
                                                    <input type="text" id="proposerName"
                                                        class="form-control formControl" formControlName="proposerName"
                                                        minlength="1" maxlength="100" (focus)="startFieldTimer()"
                                                        (keypress)="FormValidators.IsAlphabet($event);"
                                                        (keyup)="FormValidators.IsAlphaMobile($event,GetGoingFormGroup,'proposerName');"
                                                        aria-label="proposerName" autocomplete="off" name="proposerName"
                                                        pattern="^[a-zA-Z ]*$"
                                                        (blur)="FormValidators.IsSpaceInput(GetGoingFormGroup, 'proposerName'); googleAnalyticFullName()"
                                                        (input)="FormValidators.RemoveExtraSpace(GetGoingFormGroup, 'proposerName')"
                                                        (keydown.Tab)="onDown($event,gender)"
                                                        (keydown.enter)="onDown($event,gender)" required />
                                                    <label class="formLabel" for="proposerName"
                                                        [ngClass]="(GetGoingFormGroup.controls['proposerName'].value) ? 'atTop' : 'atBottom'">Full
                                                        Name
                                                    </label>
                                                </div>
                                                <div class="guidance-text">As per your PAN card</div>
                                                <div *ngIf="FormValidators.FieldHasErrors(GetGoingFormGroup,'proposerName')"
                                                    class="bottom-spc-10">
                                                    <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'proposerName','required')">
                                                        Please provide Proposer name</div>
                                                    <!-- <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'proposerName','pattern')">
                                                        Please provide valid Proposer name</div> -->
                                                    <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'proposerName','lastNameMandatory')">
                                                        Last name is mandatory.</div>
                                                </div>
                                            </div>

                                        </div>

                                        <!-- <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 mobile-no-pad"> -->
                                            <!-- Gender Field -->
                                            <!-- <div class="form-group col-xs-12 col-md-12 pad-right-10">
                                                <label class="formLabel test text-nowrap dob-label">
                                                    <span>Gender</span>
                                                </label>
                                                <div class="input-group align-center"
                                                    [ngClass]="FormValidators.FieldHasErrors(GetGoingFormGroup,'gender') ? 'text-danger':'' ">
                                                    <div *ngFor="let item of genderList ; let ind = index"
                                                        class="radio-custom gender-border "
                                                        [ngClass]="{'gender-color' : selectedGender && item === selectedGender }">
                                                        <input type="radio" #gender id="gender_{{ind}}" name="gender"
                                                            formControlName="gender" value="{{item}}"
                                                            (change)="OnGenderSelection(GetGoingFormGroup.controls['gender'].value); googleAnalyticGender();"
                                                            [checked]="selectedGender && item === selectedGender"
                                                            (keydown.esc)="onDown($event)"
                                                            (keydown.enter)="onEnter($event)"
                                                            (keydown.space)="onSpace($event , digit1 , digit2);toggleFemale($event,digit1,digit2)"
                                                            [attr.disabled]="disableBtn ? disableBtn : null" />
                                                        <label class="margin0" for="gender_{{ind}}"
                                                            [ngClass]="{'genderlabel-color' : selectedGender && item === selectedGender }"
                                                            [ngClass]="(selectedGender && item === selectedGender) ? 'selected' : ''">{{item
                                                            | titlecase}}
                                                        </label>
                                                    </div>
                                                </div>

                                                <div *ngIf="FormValidators.FieldHasErrors(GetGoingFormGroup,'gender')">
                                                    <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'gender','required')">
                                                        Mandatory field.
                                                    </div>
                                                </div>
                                            </div> -->
                                        <!-- </div> -->


                                        <div class="col-sm-12 col-xs-12 col-md-12 top-spc-20 col-lg-12 mobile-no-pad">
                                            <div class="col-md-2"></div>
                                            <!-- Mobile Field -->
                                            <div class="form-group col-xs-12 col-md-12 mobileField1">
                                                <div class="input-group box-border mobile-placeholder"
                                                    [ngClass]="FormValidators.HasError(GetGoingFormGroup, 'mobileNumber','required') || IsCorrectMobile ? 'text-danger': FormValidators.HasError(GetGoingFormGroup, 'mobileNumber','pattern') ? 'text-danger':(isMobileFieldDisable ? 'disabledDiv   ' : '' )">
                                                    <input #input4 id="mobileNumber" type="tel"
                                                        [readonly]="isMobileFieldDisable ? isMobileFieldDisable : false"
                                                        [disabled]="isMobileFieldDisable" (paste)="IsPaste($event)"
                                                        (keypress)="prevent($event);FormValidators.IsNumeric($event)"
                                                        maxlength="10" minlength="10"
                                                        class="form-control formControl mob-number"
                                                        formControlName="mobileNumber" aria-label="Mobile Number"
                                                        pattern="^\d{10}$"
                                                        (keyup)="prevent($event);FormValidators.IsNumberMobile($event,GetGoingFormGroup,'mobileNumber')"
                                                        name="mobileNumber" autocomplete="off"
                                                        (input)="ValidateMobile();FormValidators.onInputEntry($event, input1)"
                                                        (focus)="startFieldTimer()"
                                                        (blur)="googleAnalyticMobileNumber()"
                                                        (change)="getSystemToken()" required
                                                        placeholder="Mobile Number">
                                                    <label class="formLabel mobileNumaber"
                                                        [ngClass]="(GetGoingFormGroup.controls['mobileNumber'].value) ? 'atTop' : 'dont-display'"
                                                        for="mobileNumber">Mobile Number
                                                    </label>
                                                    <span class="country-code">+91</span>
                                                </div>
                                                <div class="clearfix"></div>
                                                <div class="guidance-text">Will be used for communication</div>
                                                <div class="text-danger"
                                                    *ngIf="FormValidators.FieldHasErrors(GetGoingFormGroup, 'mobileNumber') || IsCorrectMobile">
                                                    <div
                                                        *ngIf="FormValidators.FieldHasSpecificError(GetGoingFormGroup, 'mobileNumber', 'required')">
                                                        Please provide your mobile number.
                                                    </div>
                                                    <!-- Form validation for mobile number-->
                                                    <div
                                                        *ngIf="FormValidators.FieldHasSpecificError(GetGoingFormGroup, 'mobileNumber', 'minlength')">
                                                        Mobile number should be 10 digit long.
                                                    </div>
                                                    <div
                                                        *ngIf="!FormValidators.FieldHasSpecificError(GetGoingFormGroup, 'mobileNumber', 'minlength') && FormValidators.FieldHasSpecificError(GetGoingFormGroup, 'mobileNumber', 'pattern')">
                                                        Please provide valid mobile number.
                                                    </div>
                                                    <div
                                                        *ngIf="!FormValidators.FieldHasErrors(GetGoingFormGroup, 'mobileNumber') && IsCorrectMobile">
                                                        {{IsCorrectMobile}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 mobile-no-pad">
                                            <!-- Date of Birth Form Group -->
                                            <!-- <div class="form-group top-spc-10 col-xs-12 col-md-12">
                                                <label class="formLabel test text-nowrap dob-label">
                                                    <span>Date of Birth</span>
                                                    <button
                                                        *ngIf="(GetGoingFormGroup.controls['day'].value) && (GetGoingFormGroup.controls['month'].value) && (GetGoingFormGroup.controls['year'].value)"
                                                        class="btn" (click)="$event.preventDefault()">
                                                    </button>

                                                </label>
                                                <div class="col-xs-12 no-pad border-spc">
                                                    <div class="input-group top-m-5">
                                                        <div class="dob-flex dob-bottom-line">
                                                            <div class="dob-sub-flex placeholder-center">
                                                                <input #input1 id="DD" data_target="MM"
                                                                    (focus)="startFieldTimer()"
                                                                    pattern="^(0?[1-9]|[12]\d|3[01])$" min="1" max="31"
                                                                    maxlength="2" type="tel"
                                                                    class="form-control formControl change"
                                                                    aria-label="Date" name="day" placeholder="DD"
                                                                    formControlName="day"
                                                                    (blur)="FormValidators.addingZero($event); validateYear(); googleAnalyticDOB('DD')"
                                                                    (input)="FormValidators.onInputEntry($event, input2)"
                                                                    (keypress)="FormValidators.IsNumeric($event)"
                                                                    (keyup)="FormValidators.IsNumberMobile($event,GetGoingFormGroup,'day')">
                                                                <label class="formLabel"
                                                                    [ngClass]="(GetGoingFormGroup.controls['day'].value) ? 'atTop' : 'dont-display'"
                                                                    for="DD">Date
                                                                </label>
                                                            </div>
                                                            <span class="col-xs-1 slash-divider">/</span>
                                                            <div class="dob-sub-flex  placeholder-center">
                                                                <input #input2 id="MM" data_target="YYYY"
                                                                    (focus)="startFieldTimer()"
                                                                    pattern="^(0?[1-9]|1[012])$" min="1" max="12"
                                                                    maxlength="2" type="tel"
                                                                    class="form-control formControl col-md-4 col-xs-4 change"
                                                                    aria-label="Month" name="month" placeholder="MM"
                                                                    formControlName="month"
                                                                    (blur)="FormValidators.addingZero($event); validateYear(); googleAnalyticDOB('MM')"
                                                                    (input)="FormValidators.onInputEntry($event, input3)"
                                                                    (keypress)="FormValidators.IsNumeric($event)"
                                                                    (keyup)="FormValidators.IsNumberMobile($event,GetGoingFormGroup,'month')">
                                                                <label class="formLabel"
                                                                    [ngClass]="(GetGoingFormGroup.controls['month'].value) ? 'atTop' : 'dont-display'"
                                                                    for="DD">Month
                                                                </label>
                                                            </div>
                                                            <span class="col-xs-1 slash-divider">/</span>
                                                            <div class="dob-sub-flex placeholder-center">
                                                                <input #input3 id="YYYY" maxlength="4" type="tel"
                                                                    (focus)="startFieldTimer()" formControlName="year"
                                                                    (input)="scrollDown($event);"
                                                                    class="form-control formControl col-md-4 col-xs-4 change"
                                                                    style="padding:0" pattern="[0-9]{4}$"
                                                                    aria-label="Year" name="year" placeholder="YYYY"
                                                                    (keypress)="FormValidators.IsNumeric($event)"
                                                                    (keyup)="FormValidators.IsNumberMobile($event,GetGoingFormGroup,'year')"
                                                                    (input)="FormValidators.onInputEntry($event, input6); "
                                                                    (blur)="validateYear(); googleAnalyticDOB('YY')"
                                                                    required>
                                                                <label class="formLabel"
                                                                    [ngClass]="(GetGoingFormGroup.controls['year'].value) ? 'atTop' : 'dont-display'"
                                                                    for="DD">Year
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="clearfix"></div>
                                                    <div class="guidance-text">Enter DOB as per PAN Card</div>
                                                    <div
                                                        *ngIf="FormValidators.FieldHasErrors(GetGoingFormGroup,'day')  || FormValidators.FieldHasErrors(GetGoingFormGroup,'month') || FormValidators.FieldHasErrors(GetGoingFormGroup,'year')">
                                                        <div class="text-danger"
                                                            *ngIf="((FormValidators.HasError(GetGoingFormGroup,'day','required') || FormValidators.HasError(GetGoingFormGroup,'month','required') || FormValidators.HasError(GetGoingFormGroup,'year','required')) && !FormValidators.HasError(GetGoingFormGroup,'year','rangeError') && !IsDobError)">
                                                            This is a mandatory field.</div>
                                                        <div class="text-danger dob-err-pad-spec text-left"
                                                            *ngIf="!FormValidators.HasError(GetGoingFormGroup,'year','pattern') && FormValidators.HasError(GetGoingFormGroup,'year','rangeError') && (!FormValidators.HasError(GetGoingFormGroup,'day','required') || !FormValidators.HasError(GetGoingFormGroup,'month','required') || !FormValidators.HasError(GetGoingFormGroup,'year','required')) && !IsDobError">
                                                            {{GetGoingFormGroup.controls['year'].errors.rangeError}}
                                                        </div>
                                                        <div class="text-danger" *ngIf="IsDobError">
                                                            {{dobError}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="col-md-2"></div>




                                            <!-- Pincode Field -->
                                            <div class="form-group top-spc-10 col-xs-12 col-md-12 bot-spc-25">
                                                <div class="input-group pincode-group"
                                                    [ngClass]="FormValidators.FieldHasErrors(GetGoingFormGroup,'pinCode') ? 'text-danger':'' ">
                                                    <input #input6 id="pinCode" type="tel" pattern="^[0-9]{6}$"
                                                        maxlength="6" formControlName="pinCode"
                                                        class="form-control text-capitalize formControl pincode"
                                                        autocomplete="off" (input)="OnPincodeChange($event)"
                                                        (blur)="FormValidators.IsSpaceInput(GetGoingFormGroup, 'pinCode'); googleAnalyticPinCode()"
                                                        (keyup)="prevent($event);FormValidators.IsNumberMobile($event,GetGoingFormGroup,'pinCode')"
                                                        (keypress)="prevent($event);FormValidators.IsNumeric($event)"
                                                        (focus)="startFieldTimer()" placeholder="Pin Code"
                                                        required>
                                                    <label class="formLabel head-padding-spec"
                                                        [ngClass]="(GetGoingFormGroup.controls['pinCode'].value) ? 'atTop' : 'dont-display'">Residential
                                                        Pin Code</label>
                                                </div>
                                                <div class="clearfix"></div>
                                                <div *ngIf="FormValidators.FieldHasErrors(GetGoingFormGroup,'pinCode')">
                                                    <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'pinCode','required')">
                                                        Please provide your PIN code
                                                    </div>
                                                    <div class="text-danger"
                                                        *ngIf="FormValidators.HasError(GetGoingFormGroup,'pinCode','pattern')">
                                                        Please provide your correct PIN code
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12 mobile-no-pad">
                                            <!-- Terms and conditions -->
                                            <div class="col-sm-12 col-xs-12 col-md-12 tnc-label  txt-justify-align"
                                                *ngIf="!bflJourney">
                                                By Clicking on "Get Quote" you, agreed to our <span class="terms-link"
                                                    (click)="openDrawer('termsDrawer')">Privacy
                                                    Policy & Terms of
                                                    use</span>
                                            </div>
                                            <div class="col-sm-12 col-xs-12 col-md-12 tnc-label d-pad-lft-15 txt-justify-align"
                                                *ngIf="bflJourney">
                                                By clicking on “Get Quote”, you hereby declare that you have read,
                                                understood and agree with the <span class="terms-link"><a
                                                        href="https://www.bajajfinserv.in/insurance/insurance-terms-and-conditions-legal-and-compliance"
                                                        target="_blank">BFL Privacy Policy, Terms of Use, Disclaimer
                                                    </a></span> etc on BFL website and authorize Bajaj Finance Ltd.,
                                                its
                                                business partners/ group /subsidiary companies to contact you for
                                                providing products/services & to send promotional communications to
                                                you.
                                            </div>
                                            <!-- whatsapp consent -->
                                            <!-- <div *ngIf="ShowConsent && bflJourney"
                                                class="col-md-12 top-spc-20 col-xs-12 whatsAppSection mob-t0">
                                                <input id="whatsApp" class="checkbox-custom" name="whatsApp"
                                                    type="checkbox" [ngModelOptions]="{standalone: true}"
                                                    [(ngModel)]="whatsAppConsent" (change)="checkUserConsent()">
                                                <label for="whatsApp" class="tnc-label">
                                                    I hereby consent to receive policy & marketing related
                                                    communications via
                                            <img class="whatsapp-icon" loading="lazy"
                                                src="assets/img/svg/whatsapp-logo.svg" width="25" alt="whatsapp-icon" />
                                            <span class="bold"> WhatsApp </span>
                                            </label>
                                        </div> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="bottom-spc-20 btn-margin">
                                    <div class="top-spc-0 age-change-message" *ngIf="serviceMessage !== ''">
                                        {{serviceMessage}}
                                    </div>
                                </div>

                                <div class="full-width-btn" *ngIf="!showLoader">
                                    <div class="form-group btn-center btn-align-lt top-spc-20 no-bottom">
                                        <button [disabled]="!FormValidators.isGetQuoteEnable" type="button"
                                            class="btn btn-primary btnconfirm btn-single get-quote"
                                            (click)="Next(); cleverTapPayload();">
                                            <!-- VIEW PREMIUM -->
                                            GET QUOTE
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 light-gray-background no-margin d-margin-btm-50 dont-display">
                <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1">
                    <div class="top-margin-40 instruction-heading">How to Apply For Health Insurance</div>
                    <div class="col-md-12 d-pad-lft-15 top-spc-20 bottom-20">
                        <ul class="list-inline">
                            <li class="list-inline-item m-pad-0">
                                <ul class="list-inline">
                                    <li class="list-inline-item m-pad-btm-10">
                                        <img class="img-spec-val" loading="lazy"
                                            src="assets/img/Health Insurance_assets_Choose.png"
                                            alt="Choose coverage image">
                                    </li>
                                    <li class="list-inline-item">
                                        <hr class="d-img-hr">
                                    </li>
                                    <div>
                                        <span class="img-label">Choose</span>
                                        <p class="d-img-sub-label">Your Coverage</p>
                                    </div>
                                </ul>
                            </li>
                            <li class="list-inline-item m-pad-rgt-0">
                                <ul class="list-inline">
                                    <li class="list-inline-item m-pad-btm-10">
                                        <img class="img-spec-val" loading="lazy"
                                            src="assets/img/Health Insurance_assets_complete.png"
                                            alt="complete payment image">
                                    </li>
                                    <li class="list-inline-item">
                                        <hr class="d-img-hr">
                                    </li>
                                    <p class="img-label m-pad-lft-5">Complete</p>
                                    <p class="d-img-sub-label m-pad-lft-5">Payment</p>
                                </ul>
                            </li>
                            <li class="list-inline-item m-no-pad">
                                <ul class="list-inline">
                                    <li class="list-inline-item m-pad-rgt-0 m-pad-btm-10">
                                        <img class="img-spec-val" loading="lazy"
                                            src="assets/img/Health Insurance_assets_Fill.png" alt="Fill form image">
                                    </li>
                                    <li class="list-inline-item m-pad-rgt-0">
                                        <hr class="d-img-hr">
                                    </li>
                                    <p class="img-label m-pad-lft-5">Fill</p>
                                    <p class="d-img-sub-label m-pad-lft-5">Form</p>
                                </ul>
                            </li>
                            <li class="list-inline-item m-pad-rgt-0">
                                <ul class="list-inline">
                                    <li class="list-inline-item m-pad-btm-10">
                                        <img class="img-spec-val" loading="lazy"
                                            src="assets/img/Health Insurance_assets_Assestments.png"
                                            alt="Assessments image">
                                    </li>
                                    <li class="list-inline-item m-pad-rgt-0">
                                        <hr class="d-img-hr">
                                    </li>
                                    <p class="img-label">Assessment</p>
                                    <p class="d-img-sub-label">By Insured</p>
                                </ul>
                            </li>
                            <li class="list-inline-item m-policy-pad">
                                <ul class="list-inline">
                                    <li class="list-inline-item m-pad-btm-10">
                                        <img class="img-spec-val" loading="lazy"
                                            src="assets/img/Health Insurance_assets_Policy.png"
                                            alt="policy issue image">
                                    </li>
                                    <p class="img-label m-tex-center">Policy</p>
                                    <p class="d-img-sub-label m-tex-center">Issue</p>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="showOtpDrawer && !isMobile()">
            <section *ngIf="showLoader">
                <app-loader></app-loader>
            </section>
            <div class="otp-box">
                <ng-container *ngTemplateOutlet="otpBody"></ng-container>
            </div>
        </ng-container>
    </div>

</div>
<!-- Policy & terms drawer -->
<app-drawer [isModal]='true' [drawerId]="'termsDrawer'" [width]="'half'">
    <div class="drawer-info p-10">
        <h5>Privacy Policy & Terms of use</h5>
        <div class="tnc-label" [innerHTML]="termsContent">
        </div>
    </div>
</app-drawer>
<ng-template #otpBody>
    <div class="drawer-info p-3 pt-4 pb-5">
        <div class="col opt-container">
            <div class="pl-1">
                <h4 class="text-bold mt-3 mb-4">OTP Verification</h4>
                <div class="mb-4 sub-txt">
                    <div class="mr-05 d-inline-block">Enter 6 digit OTP sent to your mobile number +91 {{
                        mobileNumber
                        }}</div>
                </div>
            </div>
            <div class="otp-control">
                <form [formGroup]="healthOtpForm">
                    <div class="digit-group bot-spc-10 center m-t-2">
                        <input #digit1 formControlName="digit1" type="tel"
                            (keydown)="onKeydown($event, digit1, digit2)" aria-label="otp"
                            (input)="onOTPReceive(digit1,'input',digit2);FormValidators.onInputEntry($event, digit2)"
                            (focus)="onOTPReceive(digit1,'focus')" (blur)="googleAnalyticOtpTime('1')"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (click)="onOTPReceive(digit1,'click');" (paste)="onPaste($event, digit1)"
                            (blur)="onOTPReceive(digit1,'blur');" />
                        <input #digit2 formControlName="digit2" type="tel" (keydown)="onKeydown($event, digit1, digit3)"
                            (input)="FormValidators.onInputEntry($event, digit3)" (blur)="googleAnalyticOtpTime('2')"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event, digit2)" />
                        <input #digit3 formControlName="digit3" type="tel" (keydown)="onKeydown($event, digit2, digit4)"
                            (input)="FormValidators.onInputEntry($event, digit4)" (blur)="googleAnalyticOtpTime('3')"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event, digit3)" />
                        <input #digit4 formControlName="digit4" type="tel" (keydown)="onKeydown($event, digit3, digit5)"
                            (input)="FormValidators.onInputEntry($event, digit5)" (blur)="googleAnalyticOtpTime('4')"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event, digit4)" />
                        <input #digit5 formControlName="digit5" type="tel" (keydown)="onKeydown($event, digit4, digit6)"
                            (input)="FormValidators.onInputEntry($event, digit6)" (blur)="googleAnalyticOtpTime('5')"
                            (keypress)="FormValidators.IsNumeric($event)" pattern="^[0-9]*$" maxlength="1"
                            (paste)="onPaste($event, digit5)" />
                        <input #digit6 formControlName="digit6" type="tel" (keydown)="onKeydown($event, digit5, digit6)"
                            (blur)="googleAnalyticOtpTime('6')" maxlength="1" (paste)="onPaste($event, digit6)" />
                    </div>
                </form>
                <div class="spc-btwn bot-spc-10">
                    <div class="col-md-3 d-md-flex mt-2" *ngIf="resendOTPCount < 5">
                        <span>
                            <span id="timer">00:60</span>
                        </span>
                    </div>
                    <div class="col-md-4 bot-spc-10 text-center otpfont text-success "
                        *ngIf="resendOTPCount > 0 && resendOTPCount < 5 && isTimerStarted">OTP sent successfully! </div>
                    <a class="resend-mob-otp-link mb-1" (click)="resendOTP(); googleAnalyticResendOtp()"
                        href="javascript:void(0);" [ngClass]="{'grey-link':isTimerStarted || mobileOtpTrails >= 5}"
                        *ngIf="resendOTPCount < 5">Resend OTP?</a>
                </div>

                <div class="row bot-spc-10" *ngIf="ServiceOTPError || wrongOtpMsg || (resendOTPCount >= 5)">
                    <div class="col-xs-12 center mb-1">
                        <span class="text-danger fontStyle"
                            *ngIf="ServiceOTPError && resendOTPCount < 5">{{ServiceOTPError}}</span>
                        <span class="text-danger fontStyle"
                            *ngIf="wrongOtpMsg && resendOTPCount < 5">{{wrongOtpMsg}}</span>
                        <span class="text-danger fontStyle" *ngIf="resendOTPCount >= 5">
                            You've exhausted all 5 attempts to enter the correct OTP.
                            Please resume your application after 10 minutes.
                        </span>
                    </div>
                </div>
                <!-- Submit Button  -->
                <!-- <div class="center">
                    <button class="btn btn-primary btnconfirm btn-single" type="submit"
                        (click)="validateOtp()">Proceed</button>
                </div> -->
                <!-- Submit Button -->
            </div>
        </div>
    </div>
</ng-template>

<app-drawer class="hide-desktop" [isModal]='false' [allowBodyScroll]="true" [drawerId]="'resumeOtpDrawer'"
    [width]="'half'" [backdropDisable]="true">
    <ng-container *ngTemplateOutlet="otpBody"></ng-container>
</app-drawer>



<app-drawer [isModal]='true' (backdrop)="patchInsuringFor()" [drawerId]="'insuringForDrawer'" [width]="'half'"
    class="topDropdown">
    <div class="sum-container">
        <div class="clearfix col-xs-12 side-pad0">
            <div class="coverage-amt-label">Insuring For</div>
        </div>
        <form [formGroup]="SelectInsurerFormGroup" class="insurer-section">
            <div class="popup-height">
                <div class="col-xs-12 no-pad checkbox-block">
                    <div class="text-center mar-spc20">
                        <p class="text-center error-spec">{{errorMessage}}</p>
                        <div class="clearfix col-xs-12 col-md-6 side-pad0" formArrayName="insurer"
                            *ngFor="let item of InsuredMemberList; let i = index" (click)="triggerInsuringFor(i, 'input2')">

                            <label class="gray-background spc-between select-option"
                                [ngClass]="{'active-item': SelectInsurerFormGroup.get('insurer').value[i]}"
                                for="insuredMember{{i}}">
                                <div>{{item.title}}</div>
                                <input type="checkbox" id="insuredMember{{i}}" [formControlName]="i"
                                     />
                                <label class="mt-15" for="insuredMember{{i}}" (click)="$event.stopPropagation()">
                                </label>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="clearfix col-xs-12 col-md-12 no-pad checkbox-block">
                    <div class="clearfix mar-spc20 clearfix col-xs-12 col-md-6 side-pad0" (click)="triggerSonCheckbox()">
                        <div>
                            <div class="child-input">
                                <label class="gray-background spc-between select-option"
                                    [ngClass]="{'active-item': SonCount > 0}" for="son">
                                    Son
                                    <input type="checkbox" id="son" formControlName="son"
                                        [ngClass]="SonCount === lastSonCount ? 'disable' : ''" />
                                    <label class="mt-15" for="son"
                                        [ngClass]="DaughterCount === 4 ? 'label-before': ''" (click)="$event.stopPropagation()"></label>
                                </label>
                                <div class="counter cboth" *ngIf="SonCount > 0">
                                    <div class="gray-background select-option card-extend">
                                        <div>How many sons do you have ?</div>
                                        <div class="center">
                                            <ng-container *ngFor='let in of counter(4) ;let i = index'>
                                                <div (click)="ChangeSonCount(i+1,  $event)"
                                                    [ngClass]="{'selected-circle-btn' : SonCount === (i+1), 'disable-circle-btn': (i+1) > lastSonCount}"
                                                    class="circle-btn center">{{i+1}}</div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix mar-spc20 clearfix col-xs-12 col-md-6 side-pad0" (click)="triggerDaughterCheckbox()">
                        <div>
                            <div class="child-input">
                                <label class="gray-background spc-between select-option"
                                    [ngClass]="{'active-item': DaughterCount > 0}" for="daughter">
                                    Daughter
                                    <input type="checkbox" id="daughter" formControlName="daughter"
                                        [ngClass]="(DaughterCount === lastDaughterCount) ? 'disable' : ''" />
                                    <label class="mt-15" for="daughter"
                                        [ngClass]="SonCount === 4 ? 'label-before': ''" (click)="$event.stopPropagation()"></label>
                                </label>
                                <div class="counter cboth" *ngIf="DaughterCount > 0">
                                    <div class="gray-background select-option card-extend">
                                        <div>How many daughters do you have ?</div>

                                        <div class="center">
                                            <ng-container *ngFor='let in of counter(4) ;let i = index'>
                                                <div (click)="ChangeDaughterCount(i+1, $event)"
                                                    [ngClass]="{'selected-circle-btn' : DaughterCount === (i+1), 'disable-circle-btn': (i+1) > lastDaughterCount}"
                                                    class="circle-btn center">{{i+1}}</div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-xs-12 no-pad checkbox-block">
                    <div class="text-center mar-spc20">
                        <div>
                            <div class="clearfix col-xs-12 col-md-6 side-pad0 otherMember" formArrayName="otherInsurer"
                                *ngFor="let item of InsuredOtherMemberList; let i = index" (click)="triggerInsuringFor2(i , 'input')">
                                <label class="gray-background spc-between select-option"
                                    [ngClass]="{'active-item': SelectInsurerFormGroup.get('otherInsurer').value[i]}"
                                    for="insuredOtherMember{{i}}">
                                    <div>{{item.title}}</div>
                                    <input type="checkbox" id="insuredOtherMember{{i}}" [formControlName]="i"
                                         />
                                    <label for="insuredOtherMember{{i}}" class="mt-15" (click)="$event.stopPropagation()">
                                    </label>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- dob -->
            <div *ngIf="showEldestDOB()" class="top-spc-10 col-xs-12 col-md-12">
                <div class="col-xs-12 col-md-12 m-b-5">
                    <label class="formLabel test text-nowrap eldest-mem-spec mb-2">
                        <div class="white-text">Please confirm DOB of Eldest Member</div>
                    </label>
                </div>

                <div class="col-md-7 col-xs-12 no-pad">
                    <div class="input-group top-m-5">

                        <div class="dob-flex bottom-line-only dob-bottom-line">
                            <div class="dob-sub-flex  placeholder-center">
                                <input #input1 id="DD" data_target="MM" pattern="^(0?[1-9]|[12]\d|3[01])$" min="1"
                                    max="31" maxlength="2" type="tel" class="form-control formControl change"
                                    aria-label="DD" name="day" placeholder="DD" formControlName="day"
                                    (focus)="startFieldTimer()"
                                    (blur)="FormValidators.addingZero($event); validateYearEldest(); googleAnalyticDOB('DD', 'eldest')"
                                    (input)="FormValidators.onInputEntry($event, input2)"
                                    (keypress)="FormValidators.IsNumeric($event)"
                                    (keyup)="FormValidators.IsNumberMobile($event,SelectInsurerFormGroup,'day')">
                                <label class="formLabel"
                                    [ngClass]="(SelectInsurerFormGroup.controls['day'].value) ? 'atTop' : 'dont-display'"
                                    for="DD">Date
                                </label>
                            </div>
                            <span class="col-xs-1 slash-divider">/</span>
                            <div class="dob-sub-flex  placeholder-center">
                                <input #input2 id="MM" data_target="YYYY" pattern="^(0?[1-9]|1[012])$" min="1" max="12"
                                    maxlength="2" type="tel" class="form-control formControl col-md-4 col-xs-4 change"
                                    aria-label="MM" name="month" placeholder="MM" formControlName="month"
                                    (focus)="startFieldTimer()"
                                    (blur)="FormValidators.addingZero($event); validateYearEldest(); googleAnalyticDOB('MM', 'eldest')"
                                    (input)="FormValidators.onInputEntry($event, input3)"
                                    (keypress)="FormValidators.IsNumeric($event)"
                                    (keyup)="FormValidators.IsNumberMobile($event,SelectInsurerFormGroup,'month')">
                                <label class="formLabel"
                                    [ngClass]="(SelectInsurerFormGroup.controls['month'].value) ? 'atTop' : 'dont-display'"
                                    for="DD">Month
                                </label>
                            </div>
                            <span class="col-xs-1 slash-divider">/</span>
                            <div class="dob-sub-flex placeholder-center">
                                <div class="input-group">
                                    <input #input3 id="YYYY" maxlength="4" type="tel" formControlName="year"
                                        (focus)="startFieldTimer()"
                                        class="form-control formControl col-md-4 col-xs-4 change" style="padding:0"
                                        pattern="[0-9]{4}$" aria-label="YYYY" name="year" placeholder="YYYY"
                                        (keypress)="FormValidators.IsNumeric($event)"
                                        (keyup)="FormValidators.IsNumberMobile($event,SelectInsurerFormGroup,'year')"
                                        (blur)="validateYearEldest(); googleAnalyticDOB('YY', 'eldest')" required>
                                    <label class="formLabel"
                                        [ngClass]="(SelectInsurerFormGroup.controls['year'].value) ? 'atTop' : 'dont-display'"
                                        for="DD">Year
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <div class="text-danger" *ngIf="getDateErrors()">
                        please provide a valid date
                    </div>
                    <div
                        *ngIf="!getDateErrors() && (FormValidators.FieldHasErrors(SelectInsurerFormGroup,'day')  || FormValidators.FieldHasErrors(SelectInsurerFormGroup,'month') || FormValidators.FieldHasErrors(SelectInsurerFormGroup,'year'))">
                        <div class="text-danger"
                            *ngIf="((FormValidators.HasError(SelectInsurerFormGroup,'day','required') || FormValidators.HasError(SelectInsurerFormGroup,'month','required') || FormValidators.HasError(SelectInsurerFormGroup,'year','required')) && !FormValidators.HasError(SelectInsurerFormGroup,'year','rangeError') && !IsDobError)">
                            This is a mandatory field.</div>


                        <div class="text-danger dob-err-pad-spec text-left"
                            *ngIf="!FormValidators.HasError(SelectInsurerFormGroup,'day','pattern') && FormValidators.HasError(SelectInsurerFormGroup,'day','rangeError') && !FormValidators.HasError(SelectInsurerFormGroup,'year','rangeError') && (!FormValidators.HasError(SelectInsurerFormGroup,'day','required') || !FormValidators.HasError(SelectInsurerFormGroup,'month','required') || !FormValidators.HasError(SelectInsurerFormGroup,'year','required')) && !IsDobError">
                            {{SelectInsurerFormGroup.controls['day'].errors.rangeError}}
                        </div>




                        <div class="text-danger dob-err-pad-spec text-left"
                            *ngIf="!FormValidators.HasError(SelectInsurerFormGroup,'year','pattern') && FormValidators.HasError(SelectInsurerFormGroup,'year','rangeError') && (!FormValidators.HasError(SelectInsurerFormGroup,'day','required') || !FormValidators.HasError(SelectInsurerFormGroup,'month','required') || !FormValidators.HasError(SelectInsurerFormGroup,'year','required')) && !IsDobError">
                            {{SelectInsurerFormGroup.controls['year'].errors.rangeError}}
                        </div>
                        <div class="text-danger" *ngIf="IsDobError">
                            {{dobError}}
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="col-xs-12 col-md-12 mb-20">
            <div class="col-xs-12 text-center pad-0 pt-20">
                <button type="button" [disabled]="familyCheck || !checkDOBValid()"
                    class="btn btnconfirm btnconfirm-modification  btn-primary btn-single"
                    (click)="saveInsuringForData()">
                    SELECT </button>
            </div>
        </div>
    </div>
</app-drawer>

<ng-template #newContent>
    <div class="col-lg-7 col-md-7 col-xs-12 getgoing-banner no-padding hide-mobile">
        <div class="banner-text-fullscreen">
            <h4>Health Insurance Premium Calculator</h4>

            <h6 class="dark-theme-gray">Planning your finances? Don’t skip health insurance. Medical costs are rising,
                and health issues can strike unexpectedly. A good health insurance plan
                protects your savings and ensures quality care. Use a health insurance
                premium calculator to find the right coverage at the right cost — and secure
                your future today. Investing in the right policy today means you’re better
                prepared for tomorrow — without compromising your savings or peace of
                mind.</h6>


        </div>
        <div class="col-lg-12 col-md-12 top-spc-9">
            <img class="col-lg-6 col-md-6 getgoing-banner-img-bfl" src="assets/img/medical_Image_Web.png" alt="Banner image">
            <div class="col-lg-5 col-md-5 ">
                <ul class="list-inline">
                    <li class="pointer">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center">1</p>
                        </div>
                        <div class="no-pad">
                            <h6>Comprehensive coverage</h6>
                            <div class="dark-theme-gray">We partner with leading insurers to bring your health insurance plans that
                                offer comprehensive coverage. From in patient hospitalisation to day-care
                                treatments, from organ donor expenses to modern treatment methods –
                                stay covered for all this & more.</div>

                        </div>
                    </li>
                    <li class="pointer">
                        <div class="col-md-2 col-lg-2 numbering cashLess">
                            <p class="count-num border-circle center">2</p>
                        </div>
                        <div class="no-pad">
                            <h6>Cashless treatment at 10,000+ network hospitals & No Medical
                                Underwriting required*</h6>
                            <div class="dark-theme-gray">Pan India network of 10,000+ hospitals. Providing cashless claim since the
                                insurer directly settles medical bills with the hospital. No medical
                                Underwriting needed and fast issuance of policy </div>
                        </div>

                    </li>
                    <li class="pointer">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center">3</p>
                        </div>
                        <div class="no-pad">
                            <h6>Avail Tax Benefit Under Sec 80D</h6>
                            <div class="dark-theme-gray">Under Section 80D of the Income Tax Act, tax deduction is provided for
                                premiums paid towards health insurance policies. You can avail benefits by
                                paying premium for Self upto Rs. 25,000 & Parents (if at least one of them is
                                senior citizen) up to Rs 50,000.</div>

                        </div>
                    </li>
                    <li class="pointer" *ngIf="bflJourney">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center">4</p>
                        </div>
                        <div class="no-pad">
                            <h6>Restoration & Critical Illness Benefits </h6>
                            <div class="dark-theme-gray"> Once in a policy year, we shall provide for a reload of Sum Assured upto the
                                limits in Policy/Product for unrelated illness. Extra coverage of Sum Assured
                                for list of Specified Critical illness in Policy/Product </div>

                        </div>
                    </li>
                </ul>
            </div>
        </div>


        <div (click)="scrollToSeo()" [ngClass]="showOtpDrawer ? '' : bflJourney ?'m-t-2':'m-t-18'"
            class="down-arrow-float  hide-mobile" *ngIf="!isMobile() && bflJourney">
            <div class="icon-a_downward_arrow m-b-5"></div>
        </div>

    </div>
</ng-template>
<ng-template #oldContent>
    <div class="col-lg-7 col-md-7 col-xs-12 getgoing-banner no-padding hide-mobile">
        <div class="banner-text-fullscreen">
            <h4 *ngIf="!bflJourney"> <span>Benefits</span> of buying Health Insurance</h4>
            <h6 *ngIf="!bflJourney" class="dark-theme-gray">Looking for an extensive health insurance cover? Look no
                further! Finserv MARKETS brings you customizable health insurance plans from some of the leading
                insurance partners in the market.</h6>
            <h6 *ngIf="bflJourney" class="dark-theme-gray">Bajaj Finance Limited offers optimized health insurance
                plans
                for both individuals and their families </h6>
        </div>
        <div class="col-lg-12 col-md-12 top-spc-9">
            <img class="col-lg-6 col-md-6 getgoing-banner-img" src="assets/img/png/getgoing.png" alt="Banner image"
                *ngIf="!bflJourney">
            <img class="col-lg-6 col-md-6 getgoing-banner-img-bfl" src="assets/img/MedicalImage.png" alt="Banner image"
                *ngIf="bflJourney">
            <div class="col-lg-5 col-md-5 ">
                <h6 *ngIf="!bflJourney" class="content-question-font">Why get a Health Insurance plan?</h6>
                <ul class="list-inline">
                    <li class="pointer">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center" *ngIf="!bflJourney || bflJourney">1</p>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad" *ngIf="!bflJourney">
                            <h6>Extensive Medical Coverage</h6>
                            <div class="dark-theme-gray">With adequately covered pre & post hospitalisation, day
                                care
                                procedures and more, health insurance takes care of your hefty medical bills.</div>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad" *ngIf="bflJourney">
                            <h6>Covers pandemic like COVID-19</h6>
                            <div class="dark-theme-gray">Our health insurance plans offer coverage for diseases like
                                COVID-19 so that you don't need to invest in separate policy for the same.</div>
                        </div>
                    </li>
                    <li class="pointer">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center" *ngIf="!bflJourney || bflJourney">2</p>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad" *ngIf="!bflJourney">
                            <h6>Cashless Treatments</h6>
                            <div class="dark-theme-gray">With cashless treatment available at a huge network of
                                hospitals across India, you have one less thing to worry about.</div>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad" *ngIf="bflJourney">
                            <h6>Cashless Treatment</h6>
                            <div class="dark-theme-gray">A wide pan India network of hospitals from our partners
                                allows
                                you to get cashless treatment. </div>
                        </div>
                    </li>
                    <li class="pointer">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center" *ngIf="!bflJourney || bflJourney">3</p>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad" *ngIf="!bflJourney">
                            <h6>Tax Savings</h6>
                            <div class="dark-theme-gray">Health insurance also lets you save on tax, while you stay
                                covered for health emergencies.</div>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad" *ngIf="bflJourney">
                            <h6>Paperless Digital Process </h6>
                            <div class="dark-theme-gray">Our seamless digital buying process makes sure there is no
                                tedious paperwork</div>
                        </div>
                    </li>
                    <li class="pointer" *ngIf="bflJourney">
                        <div class="col-md-2 col-lg-2 numbering">
                            <p class="count-num border-circle center" *ngIf="!bflJourney || bflJourney">4</p>
                        </div>
                        <div class="col-md-10 col-lg-10 no-pad">
                            <h6>Cumulative Bonus </h6>
                            <div class="dark-theme-gray">If you take good care of yourself, get rewarded with a
                                yearly
                                cumulative bonus for claim-free years. </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>


        <div (click)="scrollToSeo()" [ngClass]="showOtpDrawer ? '' : bflJourney ?'m-t-2':'m-t-18'"
            class="down-arrow-float  hide-mobile" *ngIf="!isMobile() && bflJourney">
            <div class="icon-a_downward_arrow m-b-5"></div>
        </div>

    </div>
</ng-template>